export default __webpack_public_path__ + "media/images/tenant/timeline/step_1-baa05d01d7541f0edc350c977a3deff9.webp";